import $ from 'jquery/src/jquery'
import { Swiper } from 'swiper'
import {Navigation, EffectFade, Pagination, Autoplay} from "swiper/modules"
Swiper.use([Navigation, Pagination, Autoplay, EffectFade])

export default () => {
    const nodeSelectors = {
        container: '[js-slider-services="container"]',
        slider: '[js-slider-services="slider"]',
        prev: '[js-slider-services="prev"]',
        next: '[js-slider-services="next"]',
        pagination: '[js-slider-services="pagination"]',
        slideTo: '[js-slider-services="slide-to"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.slider)) {
            return
        }

        initSlider()
    }

    function initSlider() {
        // This slider may not be 100% functional if there are more same sliders on the page

        let slidersContainers = document.querySelectorAll(nodeSelectors.container)

        slidersContainers.forEach(function (container, index) {
            let sliderEl = container.querySelector(nodeSelectors.slider)

            let slider = new Swiper(sliderEl, {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: false,
                speed: 300,
                navigation: {
                    nextEl: container.querySelector(nodeSelectors.next),
                    prevEl: container.querySelector(nodeSelectors.prev),
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 40,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 0,
                    },
                    1280: {
                        slidesPerView: 4,
                        spaceBetween: 0,
                    }
                }
            })
        })
    }

    return Object.freeze({
        init,
    })
}